<template>
    <Container height="with-footer">
        <div class="container mx-auto py-8 px-4 pt-(--header-height)">
            <h1 class="text-3xl font-bold mb-4">{{ $t("terms.title") }}</h1>
            <p class="text-sm text-gray-500 mb-6">{{ $t("terms.last_updated") }} {{ date }}</p>

            <p class="mb-6">{{ $t("terms.introduction") }}</p>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("terms.sections.use.title") }}</h2>
                <p>{{ $t("terms.sections.use.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("terms.sections.content.title") }}</h2>
                <p>{{ $t("terms.sections.content.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("terms.sections.termination.title") }}</h2>
                <p>{{ $t("terms.sections.termination.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("terms.sections.liability.title") }}</h2>
                <p>{{ $t("terms.sections.liability.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("terms.sections.changes.title") }}</h2>
                <p>{{ $t("terms.sections.changes.content") }}</p>
            </section>
        </div>
    </Container>
</template>

<script lang="ts" setup>
const date = new Date().toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
</script>

<style></style>
